import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

export function Wrapper(props) {
  const className = `${style.wrapper} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Chil components
   */
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
    PropTypes.string,
  ]),
};

Wrapper.defaultProps = {
  className: "",
};
